import React, { useState, useEffect } from 'react';
import Card from '../../components/common/Card';
import Button from '../../components/common/Button';
import { FaTrash, FaEye, FaCalendarAlt, FaUserAlt, FaBuilding } from 'react-icons/fa';
import { useAuth } from '../../contexts/AuthContext';
import ventasService from '../../services/ventas.service';
import { toast } from 'react-toastify';

const VentasEliminadas = () => {
  const [ventasEliminadas, setVentasEliminadas] = useState([]);
  const [loading, setLoading] = useState(true);
  const { currentUser } = useAuth();

  useEffect(() => {
    cargarVentasEliminadas();
  }, []);

  const cargarVentasEliminadas = async () => {
    try {
      setLoading(true);
      console.log('🔄 Iniciando carga de ventas eliminadas...');
      const data = await ventasService.obtenerVentasEliminadas();
      console.log('📦 Datos recibidos:', data);
      console.log('📊 Tipo de datos:', typeof data);
      console.log('📊 Es array:', Array.isArray(data));
      console.log('📊 Longitud:', data?.length);
      setVentasEliminadas(data);
      console.log('✅ Estado actualizado con ventas eliminadas');
    } catch (error) {
      console.error('❌ Error al cargar ventas eliminadas:', error);
      toast.error('Error al cargar ventas eliminadas');
    } finally {
      setLoading(false);
    }
  };

  const formatearFecha = (fecha) => {
    if (!fecha) return 'N/A';
    
    // Manejar timestamps de Firestore
    let fechaObj;
    if (fecha && typeof fecha === 'object' && fecha.toDate) {
      // Es un timestamp de Firestore
      fechaObj = fecha.toDate();
    } else if (fecha) {
      // Es una fecha normal
      fechaObj = new Date(fecha);
    } else {
      return 'N/A';
    }
    
    return fechaObj.toLocaleDateString('es-AR') + ' ' + fechaObj.toLocaleTimeString('es-AR');
  };

  const formatearTotal = (total) => {
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS'
    }).format(total || 0);
  };

  if (!currentUser || (currentUser.rol !== 'Administrador' && currentUser.rol !== 'admin' && currentUser.email !== 'danielcadiz15@gmail.com')) {
    return (
      <div className="p-6">
        <Card>
          <div className="text-center py-8">
            <h2 className="text-xl font-semibold text-e0e3-foreground mb-4">Acceso Denegado</h2>
            <p className="text-e0e3-muted">No tienes permisos para ver las ventas eliminadas.</p>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-e0e3-foreground mb-2">Ventas Eliminadas</h1>
        <p className="text-e0e3-muted">Registro de ventas que han sido eliminadas del sistema</p>
      </div>

      <Card>
        {loading ? (
          <div className="text-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
            <p className="mt-2 text-e0e3-muted">Cargando ventas eliminadas...</p>
          </div>
        ) : ventasEliminadas.length === 0 ? (
          <div className="text-center py-8">
            <FaTrash className="mx-auto text-e0e3-muted/70 text-4xl mb-4" />
            <h3 className="text-lg font-medium text-e0e3-foreground mb-2">No hay ventas eliminadas</h3>
            <p className="text-e0e3-muted">No se han eliminado ventas en el sistema.</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-white/10">
              <thead className="bg-white/[0.04]">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-e0e3-muted uppercase tracking-wider">
                    Número Venta
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-e0e3-muted uppercase tracking-wider">
                    Fecha Venta
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-e0e3-muted uppercase tracking-wider">
                    Cliente
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-e0e3-muted uppercase tracking-wider">
                    Total
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-e0e3-muted uppercase tracking-wider">
                    Eliminada por
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-e0e3-muted uppercase tracking-wider">
                    Fecha Eliminación
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-e0e3-muted uppercase tracking-wider">
                    Motivo
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-white/10">
                {ventasEliminadas.map((ventaEliminada) => (
                  <tr key={ventaEliminada.id} className="hover:bg-white/[0.06]">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <FaTrash className="text-red-500 mr-2" />
                        <span className="font-medium text-e0e3-foreground">
                          {ventaEliminada.numero_venta || ventaEliminada.numero || 'N/A'}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <FaCalendarAlt className="text-e0e3-muted/70 mr-2" />
                        <span className="text-e0e3-foreground">
                          {formatearFecha(ventaEliminada.fecha)}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <FaUserAlt className="text-e0e3-muted/70 mr-2" />
                        <span className="text-e0e3-foreground">
                          {ventaEliminada.cliente_info?.nombre_completo || ventaEliminada.cliente_nombre || 'Cliente General'}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="font-medium text-e0e3-foreground">
                        {formatearTotal(ventaEliminada.total)}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="text-e0e3-foreground">
                        {ventaEliminada.eliminado_por || ventaEliminada.usuario_eliminacion || 'Sistema'}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <FaCalendarAlt className="text-e0e3-muted/70 mr-2" />
                        <span className="text-e0e3-foreground">
                          {formatearFecha(ventaEliminada.fecha_eliminacion)}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="text-e0e3-foreground">
                        {ventaEliminada.motivo_eliminacion || ventaEliminada.motivo || 'Sin motivo'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </div>
  );
};

export default VentasEliminadas; 